import apiClient from "../config/axiosConfig.js";

export function requestFileTranscription(fileid) {
    console.log("Requesting transcription for file: ", fileid);
    return apiClient.get(
        `/api/transcription/get?id=${fileid}`,
        { }
    );
}